import styled from 'styled-components'


export const HomeCarousel = styled.div`
	display: flex;
	justify-content: center;
	flex-direction: column;
	height: calc(100vh);
	a {
		display: flex;
		justify-content: center;
		flex-direction: column;
	}
	.current--thumb {
		video,
		img,
		iframe {
			width: calc(100% - 0px);
			opacity: 1;
			visibility: visible;
			display: block;
			position: initial;
			max-width: initial;
			pointer-events: none;
			max-height: calc(100vh);
			margin: 0 auto;
			mix-blend-mode: unset;
			animation: fadeObjectIn 500ms ease;
			transition: 2s linear;
		}
		iframe {
			border: 0;
			height: 300px;
			width: calc(100% - 0px);
			margin: 0 auto;
		}
	}

	@keyframes fadeObjectIn {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}
	.next,
	.previous {
		position: fixed;
		height: calc(100vh - 130px);
		margin: auto;
		width: 30vw;
		z-index: 99;
	}
	.next {
		left: 0;
	}
	.previous {
		right: 0;
	}
	span {
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	@media screen and (max-width: 768px) {
		.current--thumb img {
			max-width: 100%;
			width: auto;
			max-height: 60vh;
		}
		iframe {
			pointer-events: initial !important;
			position: relative !important;
			z-index: 1;
		}
		video {
			position: relative !important;
			z-index: 1;
		}
	}
`;

export const Tag = styled.div`
	position: initial;
	bottom: 30px;
	left: 0;
	right: 0;
	margin: 0 auto;
	opacity: 0.6;
	line-height: 13px;
	font-size: 10px;
	font-family: "Sackers";
	letter-spacing: .15rem;
	@media screen and (max-width: 768px) {
		position: fixed;
	}
`;



export const PostTag = styled.div`
  position: initial;
  bottom: 30px;
  left: 0;
  right: 0;
  margin: 0 auto;
  opacity: 0.6;
  line-height: 12px;
  font-size: 10px;
  font-family: "Sackers";
  letter-spacing: .15rem;
  z-index: 80;
`;

export const MobileEnterButton = styled.button`
    position: fixed;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    right: 0;
    margin: 0 auto;
    padding: 2.65rem 3rem 2rem;
    border: 0;
    width: 200px;
    font-size: 1.45rem;
	text-transform:uppercase;
	cursor: pointer;
	color: black;
	background-color: white;
	-webkit-appearance: none;
	transition: background-color .25s ease, color .25s ease;
	&:hover, &:focus {
		background-color: black;
		color: white;
	}
`;

export const BackgroundVideo = styled.div`
	position: fixed;
	z-index: 0;
	background-color: white;
	left: 0;
	right: 0;
	width: 100vw;
	height: 100vh;
	top: 0;
	pointer-events: none;

	video {
		object-fit: cover;
		width: 100vw;
		height: 100vh;
		position: fixed;
		top: 0;
		left: 0;
		pointer-events: none;
	}
`;




// WEBPACK FOOTER //
// ./src/Posts/styles/index.js